import React, { useState } from 'react';
import Layout from 'layouts/manager/Layout';
import AdminForm from './Form';

export type AdminFormValues = {
  loginId: string;
  password: string;
  passwordConfirm: string;
  company: string;
  name: string;
  email: string;
  sessionType: string;
  status: string;
};

const sessionTypeOptions = [
  { value: '', label: '選択してください' },
  { value: 'multi', label: '複数セッション' },
  { value: 'unique', label: 'ユニークセッション' },
];

const statusOptions = [
  { value: '', label: '選択してください' },
  { value: 'active', label: '有効' },
  { value: 'inactive', label: '無効' },
];

// 仮の初期値（実際はAPI等で取得）
const initialData: AdminFormValues = {
  loginId: 'admin001',
  password: '',
  passwordConfirm: '',
  company: '株式会社サンプル',
  name: '管理 太郎',
  email: 'admin@example.com',
  sessionType: 'multi',
  status: 'active',
};

const Edit: React.FC = () => {
  const [form, setForm] = useState<AdminFormValues>(initialData);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  return (
    <Layout>
      <div className="flex items-center justify-between mx-auto mb-8">
        <h1 className="text-2xl font-bold text-gray-800">ログインID管理</h1>
      </div>
      <div className="p-8 mx-auto bg-white border border-gray-200 rounded-lg shadow-md">
        <div className="mb-3">
          <a href="/manager/login-id" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
        </div>
        <div className="mb-6">
          <h2 className="flex items-center justify-between w-full pt-1 pb-2 text-lg font-bold text-left text-gray-800 border-b border-gray-200">
            ログインID情報編集
          </h2>
        </div>
        <AdminForm
          form={form}
          setForm={setForm}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          showPasswordConfirm={showPasswordConfirm}
          setShowPasswordConfirm={setShowPasswordConfirm}
          sessionTypeOptions={sessionTypeOptions}
          statusOptions={statusOptions}
          isEdit={true}
        />
        <div className="flex items-center justify-between gap-4 mt-8">
          <a href="/manager/login-id" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
          <button type="submit" className="px-6 py-2 min-w-[120px] font-semibold text-white rounded bg-primary hover:bg-[#001b40] transition text-sm shadow">更新</button>
        </div>
      </div>
    </Layout>
  );
};

export default Edit;
